// 三国志 — Tier-A bundle (server/test-safe). NO image imports. Generated by create-mod.
import { RULES } from '../dominion/rules';
import { deepClone } from '../../src/mod-loader';
import { BOARD_SPACES, COLOR_GROUPS } from '../dominion/board';
import { CHANCE_CARDS, COMMUNITY_CARDS } from '../dominion/cards';
import { CHARACTERS_DATA, getCharacterById, getStartingMoney } from './characters-data';
import { CHARACTER_LORE, getLoreById } from './lore';
import data from './sanguo-excerpt.data.json';

// Balance pass 2026-07-14 (sim --mod, 200-game 8-seat melees, seeds bal-1/2):
// 關羽 won 67.5% vs the 12.5% baseline; a passive-swap probe FLIPPED the winner
// with him → idealist's flat +$50-per-GO compounds on this short atlas loop and
// no sum-34 stat spread can offset it. goBonus response curve (measured):
// 50→67.5%, 15→37.5%, 5→28.5%, 0→23.5%; 5 lands him inside the natural top
// tier (袁紹's pure capital-9 sits at ~26% with NO passive), so 5 ships.
// Probed and REVERTED as zero-effect on this map/bot: breaker 0.5, arbitrageur
// 250, tech-discount ×2, stamina threshold 6 — on sanguo the sim's win drivers
// are capital + charisma only (engine-level finding, see ledger 2026-07-14).
// Mod-level override only: the registry PRISTINE-clones mod.rules, so this
// never leaks into dominion or other mods.
const SANGUO_RULES = deepClone(RULES);
SANGUO_RULES.passives.idealist.goBonus = 5;
// Stat-mechanics wave probe (2026-07-14): an aggressive sanguo-only override
// (luck/stamina doubled, tech +50%) was tested and REVERTED — 200-game melee
// moved only 袁紹 (26→25, flag cleared); 李儒 stayed 3.5% (his deficit is the
// early capital snowball × winner-take-all amplification, not flow modifiers).
// Lifting him = stat redistribution (meaningful now that every point has a
// continuous effect) — owner flavor decision, not a rules knob.

export const sanguoExcerptData = {
  id: 'sanguo-excerpt',
  name: "三国志",
  tagline: "权力斗争与忠义的史诗",
  version: "1.0.0",

  rules: SANGUO_RULES,
  characters: CHARACTERS_DATA,
  board: { spaces: BOARD_SPACES, colorGroups: COLOR_GROUPS },
  cards: { chance: CHANCE_CARDS, community: COMMUNITY_CARDS },
  lore: CHARACTER_LORE,

  getCharacterById,
  getStartingMoney,
  getLoreById,

  maps: [],
  worlds: [data.world],
};

export default sanguoExcerptData;
